import React from 'react'
import Slider from 'react-slick'
import { graphql, useStaticQuery } from 'gatsby'
import SliderItem from './sliderItem';
import styled from 'styled-components'

const ArrowStyle = {
  padding: "12px",
  borderRadius: "50%",
  width: "50px",
  height: "50px",
  boxSizing: "border-box",
  border: "2px solid #535F6E",
  margin: "auto",
  display: "flex",
  justifyCntent: "center",
  alignItems: "center",
}
const Container = styled.div`
  margin-bottom: 45px;
  max-width: 100%;
  @media (max-width: 768px){
    padding-left: 10px;
    padding-right: 10px;
  }

`


function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} myArrow myArrow-right`}
      style={{ ...style, ...ArrowStyle
      }}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} myArrow myArrow-left`}
      style={{ ...style, ...ArrowStyle
      }}
      onClick={onClick}
    />
  );
}

const MySlider = () => {
  const {
    mercos,
    sms, 
    nuvemshop,
    lojaintegrada,
    wbuy,
    moovin
    // picpay
  } = useStaticQuery(graphql`
  query{
    wbuy: file(relativePath: { eq: "banner_wbuy.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 740) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    lojaintegrada: file(relativePath: { eq: "banner_loja_integrada.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 740) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    nuvemshop: file(relativePath: { eq: "banner_nuvemshop.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 740) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    mercos: file(relativePath: { eq: "banner_mercos.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 740) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    sms: file(relativePath: { eq: "banner_sms.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 740) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    moovin: file(relativePath: { eq: "banner_moovin.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 740) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
  `)
  return (
    <Container id="destaques">

    
      <Slider dots={true} 
      infinit={true} 
      speed={500} 
      autoplay={true}
      slideToShow={1} 
      slideToScroll={1} 
      arrows={true}
      nextArrow={<NextArrow />}
      prevArrow={<PrevArrow />}
      dotsClass="slick-dots myDots"
     
      
      >
        {[
           {
            url: 'https://www.nuvemshop.com.br/partners/tagplus',
            target: "__blank",
            background: nuvemshop.childImageSharp.fluid
          },
          {
            url: 'https://www.wbuy.com.br/?r=FAE3GIO9',
            target: "__blank",
            background: wbuy.childImageSharp.fluid
          },
          {
            url: 'https://ajuda.tagplus.com.br/pt-BR/articles/3105079-como-realizar-integracao-com-a-loja-integrada',
            target: "__blank",
            background: lojaintegrada.childImageSharp.fluid
          },
          // {
          //   url: 'https://ajuda.tagplus.com.br/pt-BR/articles/3816130-como-realizar-integracao-com-olist',
          //   target: "__blank",
          //   background: olist.childImageSharp.fluid
          // },
          //  {
          //   url: '#integracoes',
          //   target: "",
          //   background: picpay.childImageSharp.fluid
          // },
          // {
          //   url: '#integracoes',
          //   target: "",
          //   background: lojaintegrada.childImageSharp.fluid
          // },
         
          {
            url: 'https://mercos.tagplus.com.br',
            target:"__blank",
            background: mercos.childImageSharp.fluid
          },
          {
            url: 'https://ajuda.tagplus.com.br/pt-BR/articles/2892612-como-funciona-o-tagplus-sms',
            target: "_blank",
            background: sms.childImageSharp.fluid
          },
          {
            url: 'https://login.moovin.store/register?reseller=tagplus',
            target:"__blank",
            background: moovin.childImageSharp.fluid
          },

          
        ].map( (item ,key) => (<SliderItem key={key} {...item} />))}
      </Slider>
    </Container>
      )
}

export default MySlider;
